export const calculateFeedInMaxPower = (maxPeakPower: number, feedInRatio: number): number => {
  return (maxPeakPower * feedInRatio) / 100
}
